/*
 * Site-wide smooth scrolling powered by Lenis.
 * - Loads Lenis from assets/, then runs a single rAF loop.
 * - Exposes window.lenis so sections (e.g. the masked hero) can hook `scroll`.
 * - Skips on touch, under reduced motion, and inside the Shopify theme editor.
 */
(function () {
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inEditor = window.Shopify && window.Shopify.designMode;

  // Touch devices keep native scrolling. Lenis drives scroll position from a
  // permanent rAF loop on the main thread, which on a phone costs long tasks
  // and pulls the whole page off the compositor — and it replaces momentum
  // scrolling that mobile browsers already do better, and do for free.
  var isTouch = window.matchMedia('(pointer: coarse)').matches;

  if (prefersReduced || inEditor || isTouch) return;

  // Self-hosted: the CDN copy cost a DNS + TLS handshake to an origin nothing
  // else on the page uses. theme.liquid passes the asset URL, since a plain
  // .js file can't resolve asset_url itself.
  var tag = document.querySelector('script[data-lenis-src]');
  var LENIS_SRC = tag && tag.getAttribute('data-lenis-src');

  if (!LENIS_SRC) return;

  function initLenis() {
    if (!window.Lenis) return;

    var lenis = new window.Lenis({
      duration: 1.1,
      easing: function (t) {
        return Math.min(1, 1.001 - Math.pow(2, -10 * t));
      },
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1.5,
      gestureOrientation: 'vertical'
    });

    window.lenis = lenis;

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    // Smooth in-page anchor links.
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a[href^="#"]');
      if (!link) return;
      var id = link.getAttribute('href');
      if (!id || id === '#') return;
      // A fragment link carries an id, not a CSS selector. querySelector would
      // throw a SyntaxError on ids that are valid HTML but invalid selectors --
      // most commonly one starting with a digit, which is exactly what
      // reets-policy generates from a heading like "7-day exchange window".
      var target = document.getElementById(decodeURIComponent(id.slice(1)));
      if (!target) return;
      e.preventDefault();
      lenis.scrollTo(target, { offset: 0 });
    });

    // Let anything that opens a scroll-locking drawer/modal pause Lenis.
    window.addEventListener('lenis:stop', function () { lenis.stop(); });
    window.addEventListener('lenis:start', function () { lenis.start(); });

    // Announce readiness so listeners that missed init can attach.
    window.dispatchEvent(new CustomEvent('lenis:ready', { detail: lenis }));
  }

  function loadLenis() {
    if (window.Lenis) {
      initLenis();
      return;
    }
    var s = document.createElement('script');
    s.src = LENIS_SRC;
    s.async = true;
    s.onload = initLenis;
    s.onerror = function () {
      // Fail silently — native scrolling stays intact.
    };
    document.head.appendChild(s);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadLenis, { once: true });
  } else {
    loadLenis();
  }
})();
